import { Close } from '@mui/icons-material'
import { AppBar, Box, Dialog, IconButton, Toolbar, Typography } from '@mui/material'
import React from 'react'

export const ScormPlayer = ({
  open,
  onClose,
  url,
  title
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      aria-labelledby='scorm-player-title'
      aria-describedby='scorm-player-content'
      data-test='scorm-player-dialog'
    >
      <AppBar sx={{ position: 'relative', bgcolor: 'background.paper' }}>
        <Toolbar>
          <IconButton
            edge='start'
            color='inherit'
            onClick={onClose}
            aria-label='Close course player'
            sx={{ color: 'text.primary' }}
            data-test='scorm-player-close-button'
          >
            <Close />
          </IconButton>
          <Typography
            id='scorm-player-title'
            sx={{ ml: 2, flex: 1, color: 'text.primary' }}
            variant='h6'
            component='div'
            data-test='scorm-player-title'
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box display='flex' flex={1} id='scorm-player-content'>
        <iframe
          src={url}
          title={title || 'Course content'}
          width='100%'
          height='100%'
          data-test='scorm-player-iframe'
          aria-label={`${title} course player`}
        />
      </Box>
    </Dialog>
  )
}
